import { Injectable } from '@angular/core';
import { EmailTemplate, EmailTemplateCategory, EmailTestSend } from 'models';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class EmailTemplateService {
	constructor(private http: HttpClient) {}

	public get(): Observable<EmailTemplateCategory[]> {
		return this.http.get<EmailTemplateCategory[]>('api/emailtemplate/getolddash');
	}

	public getByUser(newDash: boolean): Observable<EmailTemplateCategory[]> {
		return this.http.get<EmailTemplateCategory[]>(`api/emailtemplate/getbyuser/${newDash}`);
	}

	public getById(id: number): Observable<EmailTemplate> {
		return this.http.get<EmailTemplate>(`api/emailtemplate/get/${id}`);
	}

	public edit(emailTemplate: EmailTemplate): Observable<EmailTemplate> {
		return this.http.put<EmailTemplate>('api/emailtemplate/edit', emailTemplate);
	}

	public saveEnabledFlag(emailTemplate: EmailTemplate): Observable<EmailTemplate> {
		return this.http.put<EmailTemplate>('api/emailtemplate/saveenabledflag', emailTemplate);
	}

	public saveEnabledFlagByUser(emailTemplate: EmailTemplate): Observable<EmailTemplate> {
		return this.http.put<EmailTemplate>('api/emailtemplate/saveenabledflagbyuser', emailTemplate);
	}

	public override(emailId: number): Observable<void> {
		return this.http.put<void>('api/emailtemplate/override', emailId);
	}

	public delete(emailId: number): Observable<void> {
		return this.http.put<void>('api/emailtemplate/delete', emailId);
	}

	public sendTest(emailTestSend: EmailTestSend): Observable<void> {
		return this.http.post<void>('api/emailtemplate/sendtest', emailTestSend);
	}
}
